import type { ReactNode } from "react";

import { Tooltip } from "@heroui/react";

interface RoleLockTooltipProps {
  isLocked: boolean;
  /** Finishes "Your role can't …", e.g. "connect channels". */
  action: string;
  className?: string;
  /** The button, disabled by the caller while locked. */
  children: ReactNode;
}

/**
 * A disabled button takes no hover or focus, so while locked the tooltip's
 * own trigger wraps it and says why. Unlocked, the button renders as is.
 */
export const RoleLockTooltip = ({
  isLocked,
  action,
  className,
  children,
}: RoleLockTooltipProps) => {
  if (!isLocked) return children;

  return (
    <Tooltip>
      <Tooltip.Trigger className={`*:pointer-events-none ${className ?? ""}`}>
        {children}
      </Tooltip.Trigger>
      <Tooltip.Content>
        Your role can&apos;t {action}. Ask an admin.
      </Tooltip.Content>
    </Tooltip>
  );
};
